import { UIEventHandler, forwardRef } from 'react'

import clsx from 'clsx'

interface Props {
  showing: boolean
  allWidth: number
  onScroll: UIEventHandler<HTMLDivElement>
}

const Scrollbar = forwardRef<HTMLDivElement, Props>(({ showing, allWidth, onScroll }, ref) => {
  return (
    <div
      className={clsx(
        'scrollbar-x border-primary bg-fill-primary w-full overflow-x-auto border-y pb-px',
        !showing && 'hidden'
      )}
      ref={ref}
      onScroll={onScroll}
    >
      <div style={{ width: allWidth }}></div>
    </div>
  )
})

export default Scrollbar
